// Maps the flexible intake dict into human-readable display sections.
const LABELS = {
  property: "Property",
  components: "Keep / Replace / Remove",
  shower: "Shower",
  tub: "Tub",
  vanity: "Vanity",
  toilet: "Toilet",
  flooring: "Flooring",
  wall_tile: "Wall Tile",
  plumbing: "Plumbing",
  electrical: "Electrical",
  ventilation: "Ventilation",
  walls_paint: "Walls / Paint",
  doors_windows: "Doors / Windows",
  accessibility: "Accessibility",
  jobsite: "Jobsite Conditions",
};

const FIELD_LABELS = {
  bathroom_location: "Location", floor_level: "Floor level", occupied: "Occupancy", only_bathroom: "Only bathroom?", access_notes: "Access notes",
  type: "Type", width_in: "Width (in)", depth_in: "Depth (in)", height_in: "Height (in)", bench: "Bench", niche: "Niche", niche_qty: "Niche qty",
  grab_bars: "Grab bars", glass: "Glass", drain: "Drain", location: "Location", tile_extent: "Tile extent", fixtures: "Fixtures",
  action: "Action", dimensions: "Dimensions", sinks: "Sinks", countertop: "Countertop", plumbing_location: "Plumbing location",
  replace: "Replace", material: "Material", notes: "Notes", areas: "Areas", preference: "Preference", items: "Items",
  exhaust_fan: "Exhaust fan", wanted: "Wanted", features: "Features", stairs: "Stairs", parking: "Parking", protection: "Protection", pets: "Pets",
  shower: "Shower", vanity: "Vanity", toilet: "Toilet", lighting: "Lighting", mirror: "Mirror", door: "Door", window: "Window", paint: "Paint",
};

export function humanValue(v) {
  if (v === true) return "Yes";
  if (v === false) return "No";
  if (Array.isArray(v)) return v.join(", ");
  if (typeof v === "string") return v.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return String(v);
}

export function fieldLabel(k) {
  return FIELD_LABELS[k] || k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function sectionLabel(k) {
  return LABELS[k] || k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function intakeToSections(intake) {
  const order = Object.keys(LABELS);
  const sections = [];
  const keys = order.filter((k) => intake[k]).concat(Object.keys(intake).filter((k) => !order.includes(k) && k !== "notes"));
  for (const key of keys) {
    const val = intake[key];
    if (val == null) continue;
    if (typeof val === "object" && !Array.isArray(val)) {
      const fields = Object.entries(val).filter(([, v]) => v != null && v !== "");
      if (fields.length) sections.push({ key, fields });
    }
  }
  return sections;
}
